const formatProviderList = (providers: string[]): string => {
    if (providers.length === 0) return '';
    if (providers.length === 1) return providers[0];
    return `${providers.slice(0, -1).join(', ')}, or ${providers[providers.length - 1]}`;
};

export default formatProviderList;
